function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint class-methods-use-this: "off" */
import memoize from 'memoizee';
import { debounce, set } from 'lodash';
import Log from '@deephaven/log';
import { TableUtils } from '@deephaven/jsapi-utils';
import ChartModel from "./ChartModel.js";
import ChartUtils from "./ChartUtils.js";
var log = Log.module('FigureChartModel');

/**
 * Takes a Figure object from a widget to make a model for a chart
 */
class FigureChartModel extends ChartModel {
  /**
   * @param dh JSAPI instance
   * @param figure The figure object created by the API
   * @param settings Chart settings
   */
  constructor(dh, figure) {
    var _this;
    var settings = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    super(dh);
    _this = this;
    _defineProperty(this, "chartUtils", void 0);
    _defineProperty(this, "dh", void 0);
    _defineProperty(this, "figure", void 0);
    _defineProperty(this, "settings", void 0);
    _defineProperty(this, "data", void 0);
    _defineProperty(this, "layout", void 0);
    _defineProperty(this, "seriesDataMap", void 0);
    _defineProperty(this, "pendingSeries", void 0);
    _defineProperty(this, "oneClicks", void 0);
    _defineProperty(this, "filterColumnMap", void 0);
    _defineProperty(this, "lastFilter", void 0);
    _defineProperty(this, "isConnected", void 0);
    // Assume figure is connected to start
    _defineProperty(this, "seriesToProcess", void 0);
    // We need to debounce adding series so we subscribe to them all in the same tick
    // This should no longer be necessary after IDS-5049 lands
    _defineProperty(this, "addPendingSeries", debounce(() => {
      var axisTypeMap = ChartUtils.getAxisTypeMap(this.figure);
      var pendingSeries = this.pendingSeries;
      var _loop = function _loop() {
        var _chart$showLegend;
        var series = pendingSeries[i];
        var chart = _this.figure.charts.find(c => c.series.includes(series));
        _this.addSeries(series, axisTypeMap, (_chart$showLegend = chart === null || chart === void 0 ? void 0 : chart.showLegend) !== null && _chart$showLegend !== void 0 ? _chart$showLegend : null);
        series.subscribe();
        // We'll get an update with the data after subscribing
      };
      for (var i = 0; i < pendingSeries.length; i += 1) {
        _loop();
      }
      this.pendingSeries = [];
    }, FigureChartModel.ADD_SERIES_DEBOUNCE));
    _defineProperty(this, "getTimeZone", memoize((columnType, formatter) => {
      if (formatter != null) {
        var dataFormatter = formatter.getColumnTypeFormatter(columnType);
        if (dataFormatter != null) {
          return dataFormatter.dhTimeZone;
        }
      }
      return undefined;
    }, {
      max: 100
    }));
    _defineProperty(this, "getValueTranslator", memoize((columnType, formatter) => {
      var timeZone = this.getTimeZone(columnType, formatter);
      return value => this.chartUtils.unwrapValue(value, timeZone);
    }, {
      max: 100
    }));
    /** Gets the parser for a value with the provided column type */
    _defineProperty(this, "getValueParser", memoize((columnType, formatter) => {
      var timeZone = this.getTimeZone(columnType, formatter);
      return value => this.chartUtils.wrapValue(value, columnType, timeZone);
    }, {
      max: 100
    }));
    /**
     * Gets the range parser for a particular column type
     */
    _defineProperty(this, "getRangeParser", memoize((columnType, formatter) => range => {
      var _range = _slicedToArray(range, 2),
        rangeStart = _range[0],
        rangeEnd = _range[1];
      var valueParser = this.getValueParser(columnType, formatter);
      rangeStart = valueParser(rangeStart);
      rangeEnd = valueParser(rangeEnd);
      return [rangeStart, rangeEnd];
    }, {
      max: 100
    }));
    /**
     * Gets the parser for parsing the range from an axis within the given chart
     */
    _defineProperty(this, "getAxisRangeParser", memoize((chart, formatter) => axis => {
      var source = ChartUtils.getSourceForAxis(chart, axis);
      if (source != null) {
        return this.getRangeParser(source.columnType, formatter);
      }
      return range => range;
    }, {
      max: 100
    }));
    this.handleFigureUpdated = this.handleFigureUpdated.bind(this);
    this.handleFigureDisconnected = this.handleFigureDisconnected.bind(this);
    this.handleFigureReconnected = this.handleFigureReconnected.bind(this);
    this.handleFigureSeriesAdded = this.handleFigureSeriesAdded.bind(this);
    this.handleDownsampleStart = this.handleDownsampleStart.bind(this);
    this.handleDownsampleFinish = this.handleDownsampleFinish.bind(this);
    this.handleDownsampleFail = this.handleDownsampleFail.bind(this);
    this.handleDownsampleNeeded = this.handleDownsampleNeeded.bind(this);
    this.handleRequestFailed = this.handleRequestFailed.bind(this);
    this.dh = dh;
    this.chartUtils = new ChartUtils(dh);
    this.figure = figure;
    this.settings = settings;
    this.data = [];
    this.layout = {
      grid: {
        rows: figure.rows,
        columns: figure.cols,
        pattern: 'independent'
      }
    };
    this.seriesDataMap = new Map();
    this.pendingSeries = [];
    this.oneClicks = [];
    this.filterColumnMap = new Map();
    this.lastFilter = new Map();
    this.isConnected = true; // Assume figure is connected to start
    this.seriesToProcess = new Set();
    this.setTitle(this.getDefaultTitle());
    this.initAllSeries();
    this.updateAxisPositions();
    this.startListeningFigure();
  }
  close() {
    this.figure.close();
    this.addPendingSeries.cancel();
    this.stopListeningFigure();
  }
  getDefaultTitle() {
    if (this.figure.title != null && this.figure.title.length > 0) {
      return this.figure.title;
    }
    if (this.figure.charts.length === 1) {
      var _this$figure$charts$;
      return (_this$figure$charts$ = this.figure.charts[0].title) !== null && _this$figure$charts$ !== void 0 ? _this$figure$charts$ : '';
    }
    return '';
  }
  initAllSeries() {
    var _this2 = this;
    this.oneClicks = [];
    this.filterColumnMap.clear();
    var charts = this.figure.charts;
    var axisTypeMap = ChartUtils.getAxisTypeMap(this.figure);
    var activeSeriesNames = [];
    this.seriesToProcess = new Set();
    var _loop2 = function _loop2() {
      var chart = charts[i];
      for (var j = 0; j < chart.series.length; j += 1) {
        var series = chart.series[j];
        activeSeriesNames.push(series.name);
        _this2.addSeries(series, axisTypeMap, chart.showLegend);
      }

      // Need to add the chart titles as annotations if they are set
      var axes = chart.axes,
        title = chart.title;
      if (title != null && title.length > 0 && (charts.length > 1 || _this2.figure.title != null)) {
        var xAxis = axes.find(axis => axis.type === _this2.dh.plot.AxisType.X);
        var yAxis = axes.find(axis => axis.type === _this2.dh.plot.AxisType.Y);
        if (xAxis == null || yAxis == null) {
          log.warn('Chart title provided, but unknown how to map to the correct axes for this chart type', chart);
        } else {
          var _axisTypeMap$get$find, _axisTypeMap$get, _axisTypeMap$get$find2, _axisTypeMap$get2;
          var xAxisIndex = ((_axisTypeMap$get$find = (_axisTypeMap$get = axisTypeMap.get(xAxis.type)) === null || _axisTypeMap$get === void 0 ? void 0 : _axisTypeMap$get.findIndex(a => a === xAxis)) !== null && _axisTypeMap$get$find !== void 0 ? _axisTypeMap$get$find : 0) + 1;
          var yAxisIndex = ((_axisTypeMap$get$find2 = (_axisTypeMap$get2 = axisTypeMap.get(yAxis.type)) === null || _axisTypeMap$get2 === void 0 ? void 0 : _axisTypeMap$get2.findIndex(a => a === yAxis)) !== null && _axisTypeMap$get$find2 !== void 0 ? _axisTypeMap$get$find2 : 0) + 1;
          var annotation = {
            align: 'center',
            x: 0.5,
            y: 1,
            yshift: 17,
            text: title,
            showarrow: false,
            // Typing is incorrect in Plotly for this, as it doesn't seem to be typed for the "domain" part: https://plotly.com/javascript/reference/layout/annotations/#layout-annotations-items-annotation-xref
            xref: "x".concat(xAxisIndex, " domain"),
            yref: "y".concat(yAxisIndex, " domain")
          };
          if (_this2.layout.annotations == null) {
            _this2.layout.annotations = [annotation];
          } else {
            _this2.layout.annotations.push(annotation);
          }
        }
      }
    };
    for (var i = 0; i < charts.length; i += 1) {
      _loop2();
    }

    // Remove any series that no longer exist
    var allSeriesNames = [...this.seriesDataMap.keys()];
    var inactiveSeriesNames = allSeriesNames.filter(seriesName => activeSeriesNames.indexOf(seriesName) < 0);
    for (var _i = 0; _i < inactiveSeriesNames.length; _i += 1) {
      var seriesName = inactiveSeriesNames[_i];
      this.seriesDataMap.delete(seriesName);
    }
  }

  /**
   * Add a series to the model
   * @param series Series object to add
   * @param axisTypeMap Map of axis type to the axes in this Figure
   * @param showLegend Whether this series should show the legend or not
   */
  addSeries(series, axisTypeMap, showLegend) {
    var _this$renderOptions$w, _this$renderOptions;
    var dh = this.dh;
    var seriesData = this.chartUtils.makeSeriesDataFromSeries(series, axisTypeMap, ChartUtils.getSeriesVisibility(series.name, this.settings), showLegend, (_this$renderOptions$w = (_this$renderOptions = this.renderOptions) === null || _this$renderOptions === void 0 ? void 0 : _this$renderOptions.webgl) !== null && _this$renderOptions$w !== void 0 ? _this$renderOptions$w : true);
    this.seriesDataMap.set(series.name, seriesData);
    this.seriesToProcess.add(series.name);
    this.data = [...this.seriesDataMap.values()];
    if (series.plotStyle === dh.plot.SeriesPlotStyle.STACKED_BAR) {
      this.layout.barmode = 'stack';
    } else if (series.plotStyle === dh.plot.SeriesPlotStyle.PIE) {
      this.layout.hiddenlabels = ChartUtils.getHiddenLabels(this.settings);
    }

    // We only want to force hide the legend if there is only one series that is not a PIE
    // Right now this means that if the user only has one series, they cannot explicitly show the legend until deephaven-core#3254 is implemented
    // TODO: deephaven-core#3254, once done, this can be removed.
    this.layout.showlegend = this.data.length > 1 || series.plotStyle === dh.plot.SeriesPlotStyle.PIE ? showLegend !== null && showLegend !== void 0 ? showLegend : undefined : false;
    if (series.oneClick != null) {
      var oneClick = series.oneClick;
      var columns = oneClick.columns;
      for (var i = 0; i < columns.length; i += 1) {
        this.filterColumnMap.set(columns[i].name, columns[i]);
      }
      this.oneClicks.push(oneClick);
    }
    this.updateLayoutFormats();
  }
  subscribe(callback) {
    super.subscribe(callback);
    if (this.listeners.length === 1) {
      // Need to initialize the series here as we may have missed some series when not subscribed
      this.initAllSeries();
      this.subscribeFigure();
    }
  }
  unsubscribe(callback) {
    super.unsubscribe(callback);
    if (this.listeners.length === 0) {
      this.unsubscribeFigure();
    }
  }
  subscribeFigure() {
    if (!this.isConnected) {
      log.debug('Ignoring subscribe when figure in disconnected state');
      return;
    }
    this.figure.subscribe(this.isDownsamplingDisabled ? this.dh.plot.DownsampleOptions.DISABLE : this.dh.plot.DownsampleOptions.DEFAULT);
    if (this.figure.errors.length > 0) {
      log.error('Errors in figure', this.figure.errors);
      this.fireError(this.figure.errors);
    }
  }
  unsubscribeFigure() {
    this.figure.unsubscribe();
  }
  startListeningFigure() {
    var dh = this.dh;
    this.figure.addEventListener(dh.plot.Figure.EVENT_UPDATED, this.handleFigureUpdated);
    this.figure.addEventListener(dh.plot.Figure.EVENT_SERIES_ADDED, this.handleFigureSeriesAdded);
    this.figure.addEventListener(dh.plot.Figure.EVENT_DISCONNECT, this.handleFigureDisconnected);
    this.figure.addEventListener(dh.plot.Figure.EVENT_RECONNECT, this.handleFigureReconnected);
    this.figure.addEventListener(dh.plot.Figure.EVENT_DOWNSAMPLESTARTED, this.handleDownsampleStart);
    this.figure.addEventListener(dh.plot.Figure.EVENT_DOWNSAMPLEFINISHED, this.handleDownsampleFinish);
    this.figure.addEventListener(dh.plot.Figure.EVENT_DOWNSAMPLEFAILED, this.handleDownsampleFail);
    this.figure.addEventListener(dh.plot.Figure.EVENT_DOWNSAMPLENEEDED, this.handleDownsampleNeeded);
    this.figure.addEventListener(dh.Client.EVENT_REQUEST_FAILED, this.handleRequestFailed);
  }
  stopListeningFigure() {
    var dh = this.dh;
    this.figure.removeEventListener(dh.plot.Figure.EVENT_UPDATED, this.handleFigureUpdated);
    this.figure.removeEventListener(dh.plot.Figure.EVENT_SERIES_ADDED, this.handleFigureSeriesAdded);
    this.figure.removeEventListener(dh.plot.Figure.EVENT_DISCONNECT, this.handleFigureDisconnected);
    this.figure.removeEventListener(dh.plot.Figure.EVENT_RECONNECT, this.handleFigureReconnected);
    this.figure.removeEventListener(dh.plot.Figure.EVENT_DOWNSAMPLESTARTED, this.handleDownsampleStart);
    this.figure.removeEventListener(dh.plot.Figure.EVENT_DOWNSAMPLEFINISHED, this.handleDownsampleFinish);
    this.figure.removeEventListener(dh.plot.Figure.EVENT_DOWNSAMPLEFAILED, this.handleDownsampleFail);
    this.figure.removeEventListener(dh.plot.Figure.EVENT_DOWNSAMPLENEEDED, this.handleDownsampleNeeded);
    this.figure.removeEventListener(dh.Client.EVENT_REQUEST_FAILED, this.handleRequestFailed);
  }
  handleDownsampleStart(event) {
    log.debug('Downsample started', event);
    this.fireDownsampleStart(event.detail);
  }
  handleDownsampleFinish(event) {
    log.debug('Downsample finished', event);
    this.fireDownsampleFinish(event.detail);
  }
  handleDownsampleFail(event) {
    log.error('Downsample failed', event);
    this.fireDownsampleFail(event.detail);
  }
  handleDownsampleNeeded(event) {
    log.info('Downsample needed', event);
    this.fireDownsampleNeeded(event.detail);
  }
  handleFigureUpdated(event) {
    var figureUpdateEvent = event.detail;
    var seriesArray = figureUpdateEvent.series;
    log.debug2('handleFigureUpdated', seriesArray);
    for (var i = 0; i < seriesArray.length; i += 1) {
      var series = seriesArray[i];
      log.debug2('handleFigureUpdated updating series', series.name);
      var sources = series.sources;
      for (var j = 0; j < sources.length; j += 1) {
        var source = sources[j];
        var columnType = source.columnType,
          type = source.type;
        var valueTranslator = this.getValueTranslator(columnType, this.formatter);
        var dataArray = figureUpdateEvent.getArray(series, type, valueTranslator);
        this.setDataArrayForSeries(series, type, dataArray);
      }
      this.seriesToProcess.delete(series.name);
      this.cleanSeries(series);
    }
    if (this.seriesToProcess.size === 0) {
      this.fireLoadFinished();
    }
    var data = this.data;
    this.fireUpdate(data);
  }
  handleRequestFailed(event) {
    log.error('Request failed', event);
    this.fireError(["".concat(event.detail)]);
  }

  /**
   * Resubscribe to the figure, should be done if settings change
   */
  resubscribe() {
    if (this.listeners.length > 0) {
      this.unsubscribeFigure();
      this.subscribeFigure();
    }
  }
  setFormatter(formatter) {
    super.setFormatter(formatter);
    this.updateLayoutFormats();

    // Unsubscribe and resubscribe to trigger a data update
    // Data may need to be translated again because of the new formatter
    this.resubscribe();
  }
  setRenderOptions(renderOptions) {
    super.setRenderOptions(renderOptions);

    // Reset all the series to re-render them with the correct rendering options
    this.initAllSeries();
  }
  setDownsamplingDisabled(isDownsamplingDisabled) {
    super.setDownsamplingDisabled(isDownsamplingDisabled);
    this.resubscribe();
  }
  handleFigureDisconnected(event) {
    log.debug('Figure disconnected', event);
    this.isConnected = false;
    if (this.listeners.length > 0) {
      this.unsubscribeFigure();
    }
    this.fireDisconnect();
  }
  handleFigureReconnected(event) {
    log.debug('Figure reconnected', event);
    this.isConnected = true;

    // It's possible the series have changed completely, as the query could have been changed
    this.initAllSeries();
    this.fireReconnect();
    if (this.listeners.length > 0) {
      this.subscribeFigure();
    }
  }
  handleFigureSeriesAdded(event) {
    var series = event.detail;
    log.debug('handleFigureSeriesAdded', series);
    this.pendingSeries.push(series);
    this.addPendingSeries();
  }
  setDimensions(rect) {
    super.setDimensions(rect);
    this.updateAxisPositions();
  }
  setTitle(title) {
    var _match$length, _match;
    super.setTitle(title);

    // Need to recalculate the padding based on how many lines of text the title is
    // Plotly doesn't handle positioning it correctly, and it's an undocumented feature
    var subtitleCount = (_match$length = (_match = (title !== null && title !== void 0 ? title : '').match(/<br>/g)) === null || _match === void 0 ? void 0 : _match.length) !== null && _match$length !== void 0 ? _match$length : 0;
    var margin = ChartUtils.DEFAULT_MARGIN.t + subtitleCount * ChartUtils.SUBTITLE_LINE_HEIGHT;
    if (this.layout.margin) {
      this.layout.margin.t = margin;
    } else {
      this.layout.margin = {
        t: margin
      };
    }
    if (typeof this.layout.title === 'string') {
      this.layout.title = {
        text: title
      };
    } else {
      this.layout.title = _objectSpread({}, this.layout.title);
      this.layout.title.text = title;
      this.layout.title.pad = _objectSpread({}, this.layout.title.pad);
      this.layout.title.pad.t = ChartUtils.DEFAULT_TITLE_PADDING.t + subtitleCount * ChartUtils.SUBTITLE_LINE_HEIGHT * 0.5;
    }
    this.fireLayoutUpdated({
      title: this.layout.title
    });
  }
  getPlotWidth() {
    var _this$layout$margin$l, _this$layout$margin, _this$layout$margin$r, _this$layout$margin2;
    if (!this.rect || !this.rect.width) {
      return 0;
    }
    return Math.max(this.rect.width - ((_this$layout$margin$l = (_this$layout$margin = this.layout.margin) === null || _this$layout$margin === void 0 ? void 0 : _this$layout$margin.l) !== null && _this$layout$margin$l !== void 0 ? _this$layout$margin$l : 0) - ((_this$layout$margin$r = (_this$layout$margin2 = this.layout.margin) === null || _this$layout$margin2 === void 0 ? void 0 : _this$layout$margin2.r) !== null && _this$layout$margin$r !== void 0 ? _this$layout$margin$r : 0), 0);
  }
  getPlotHeight() {
    var _this$layout$margin$t, _this$layout$margin3, _this$layout$margin$b, _this$layout$margin4;
    if (!this.rect || !this.rect.height) {
      return 0;
    }
    return Math.max(this.rect.height - ((_this$layout$margin$t = (_this$layout$margin3 = this.layout.margin) === null || _this$layout$margin3 === void 0 ? void 0 : _this$layout$margin3.t) !== null && _this$layout$margin$t !== void 0 ? _this$layout$margin$t : 0) - ((_this$layout$margin$b = (_this$layout$margin4 = this.layout.margin) === null || _this$layout$margin4 === void 0 ? void 0 : _this$layout$margin4.b) !== null && _this$layout$margin$b !== void 0 ? _this$layout$margin$b : 0), 0);
  }
  updateAxisPositions() {
    var plotWidth = this.getPlotWidth();
    var plotHeight = this.getPlotHeight();
    this.chartUtils.updateFigureAxes(this.layout, this.figure, chart => this.getAxisRangeParser(chart, this.formatter), plotWidth, plotHeight);
  }

  /**
   * Updates the format patterns used
   */
  updateLayoutFormats() {
    if (!this.formatter) {
      return;
    }
    var axisFormats = this.chartUtils.getAxisFormats(this.figure, this.formatter);
    axisFormats.forEach((axisFormat, axisLayoutProperty) => {
      log.debug("Assigning ".concat(axisLayoutProperty), this.layout[axisLayoutProperty], axisFormat);
      var props = this.layout[axisLayoutProperty];
      if (props != null) {
        Object.assign(props, axisFormat);
      } else {
        log.debug("Ignoring null layout.".concat(axisLayoutProperty));
      }
    });
  }

  /**
   * Set a specific array for the array of series properties specified.
   * @param series The series to set the data array for.
   * @param sourceType The source type within that series to set the data for.
   * @param dataArray The array to use for the data for this series source.
   */
  setDataArrayForSeries(series, sourceType, dataArray) {
    var name = series.name,
      plotStyle = series.plotStyle;
    var seriesData = this.seriesDataMap.get(name);
    var property = this.chartUtils.getPlotlyProperty(plotStyle, sourceType);
    if (seriesData) {
      set(seriesData, property, dataArray);
    }
  }

  /**
   * After setting all the data in the series data, we may need to adjust some other properties
   * Eg. Calculating the width from the xLow/xHigh values; Plot.ly uses `width` instead of a low/high
   * value for x.
   * @param series The series to clean the data for
   */
  cleanSeries(series) {
    var dh = this.dh;
    var name = series.name,
      plotStyle = series.plotStyle;
    var seriesData = this.seriesDataMap.get(name);
    if (seriesData == null) {
      return;
    }
    if (plotStyle === dh.plot.SeriesPlotStyle.HISTOGRAM) {
      var xLow = seriesData.xLow,
        xHigh = seriesData.xHigh;
      if (xLow && xHigh && xLow.length === xHigh.length) {
        var width = [];
        for (var i = 0; i < xLow.length; i += 1) {
          width.push(xHigh[i] - xLow[i]);
        }
        seriesData.width = width;
      }
    } else if (plotStyle === dh.plot.SeriesPlotStyle.LINE || plotStyle === dh.plot.SeriesPlotStyle.ERROR_BAR || plotStyle === dh.plot.SeriesPlotStyle.BAR) {
      var x = seriesData.x,
        _xLow = seriesData.xLow,
        _xHigh = seriesData.xHigh,
        y = seriesData.y,
        yLow = seriesData.yLow,
        yHigh = seriesData.yHigh;
      if (_xLow && _xHigh && _xLow !== x) {
        seriesData.error_x = ChartUtils.getPlotlyErrorBars(x, _xLow, _xHigh);
      }
      if (yLow && yHigh && yLow !== y) {
        seriesData.error_y = ChartUtils.getPlotlyErrorBars(y, yLow, yHigh);
      }
    } else if (plotStyle === dh.plot.SeriesPlotStyle.TREEMAP) {
      var ids = seriesData.ids,
        labels = seriesData.labels;
      if (ids !== undefined && labels === undefined) {
        // If the user only provided IDs, we assign the IDs to the labels property as well automatically
        // Plotly uses the labels primarily, which from our API perspective seems kind of backwards
        seriesData.labels = ids;
      }
    }
  }
  getData() {
    return this.data;
  }
  getLayout() {
    return this.layout;
  }
  getFilterColumnMap() {
    return new Map(this.filterColumnMap);
  }
  isFilterRequired() {
    return this.oneClicks.find(oneClick => oneClick.requireAllFiltersToDisplay) != null;
  }

  /**
   * Coerce a filter value to the appropriate type based on column type.
   * Input filter controls always provide string values, but OneClick expects the
   * native type (e.g. number for numeric columns) to match partition keys.
   * Linkers provide the raw value, so that value should be returned as is.
   */
  coerceFilterValue(value, columnType) {
    if (value == null) {
      return value;
    }
    if (typeof value === 'string' && TableUtils.isNumberType(columnType)) {
      var num = Number(value);
      if (!Number.isNaN(num)) {
        return num;
      }
    }
    return value;
  }

  /**
   * Sets the filter on the model. Will only set the values that have changed.
   * @param filterMap Map of filter column names to values
   */
  setFilter(filterMap) {
    var _this3 = this;
    if (this.oneClicks.length === 0) {
      log.warn('Trying to set a filter, but no one click!');
      return;
    }
    log.debug('setFilter', filterMap);
    var _loop3 = function _loop3() {
      var oneClick = _this3.oneClicks[i];
      var columns = oneClick.columns;
      // Need to get all the keys in case a filter was removed
      var keys = new Set([...filterMap.keys(), ..._this3.lastFilter.keys()]);
      keys.forEach(key => {
        var rawValue = filterMap.get(key);
        var column = columns.find(c => c.name === key);
        if (_this3.lastFilter.get(key) !== rawValue && column != null) {
          var value = rawValue != null ? _this3.coerceFilterValue(rawValue, column.type) : rawValue;
          oneClick.setValueForColumn(key, value);
        }
      });
    };
    for (var i = 0; i < this.oneClicks.length; i += 1) {
      _loop3();
    }
    this.lastFilter = new Map(filterMap);
  }
  setFigure(figure) {
    this.close();
    this.figure = figure;
    this.setTitle(this.getDefaultTitle());
    this.initAllSeries();
    this.updateAxisPositions();
    this.startListeningFigure();
    if (this.listeners.length > 0) {
      this.subscribeFigure();
    }
  }
  updateSettings(settings) {
    this.settings = settings;
  }
}
_defineProperty(FigureChartModel, "ADD_SERIES_DEBOUNCE", 50);
export default FigureChartModel;
//# sourceMappingURL=FigureChartModel.js.map